import { AnalyticsEvent } from "@common/constants/analytics-events";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { UpgradeCta } from "@components/settings/Plans/UpgradeCta";
import { useEffectOnce } from "@hooks/useEffectOnce";
import { trackEvent } from "@lib/analytics";

export const ArAgingReportsPaywalled = () => {
    useEffectOnce(() => {
        void trackEvent(AnalyticsEvent.UPSELL_AR_AGING_REPORTS_ATTEMPTED);
    });

    return (
        <div className="flex flex-col w-inherit">
            <UpgradeCta
                title={
                    <>
                        AR aging reports are available on the{" "}
                        <span className="text-blue-600">Plus</span> plan
                    </>
                }
                subtitle="See exactly which invoices are overdue and by how long, broken down by customer."
                plan={FLAT_RATE_PLANS.PLUS}
            />
            <img
                src="/images/features/ar-aging.png"
                alt="Premium feature preview"
                width="100%"
            />
        </div>
    );
};
